<template>
  <div>
    <a
      class="link-preview-card"
      :href="card.url"
      target="_blank"
      rel="noopener"
    >
      <div
        v-if="useImage"
        class="card-image"
        :class="{ '-loading': !imageLoaded }"
      >
        <img
          :src="card.image"
          loading="lazy"
          alt=""
          @load="imageLoaded = true"
        >
      </div>
      <div class="card-content">
        <span class="card-host faint">
          <span
            v-if="censored"
            class="nsfw-alert alert warning"
          >{{ $t('status.nsfw') }}</span>
          {{ card.provider_name }}
        </span>
        <h4 class="card-title">{{ card.title }}</h4>
        <p
          v-if="useDescription"
          class="card-description"
        >{{ card.description }}</p>
      </div>
    </a>
  </div>
</template>

<script src="./link-preview.js"></script>

<style lang="scss">
.link-preview-card {
  display: flex;
  flex-direction: row;
  cursor: pointer;
  overflow: hidden;
  margin-top: 0.5em;

  .card-image {
    flex-shrink: 0;
    width: 120px;
    max-width: 25%;

    /* no room until the picture is there (and none if it fails); hidden,
       not display: none, under which a lazy picture never loads, and a
       pixel wide, as some browsers skip lazy pictures of no size */
    &.-loading {
      width: 1px;
      visibility: hidden;
    }

    img {
      width: 100%;
      height: 100%;
      max-height: 10em;
      object-fit: cover;
      border-radius: var(--roundness);
    }
  }

  .card-content {
    max-height: 100%;
    margin: 0.5em;
    display: flex;
    flex-direction: column;
  }

  .card-host {
    font-size: var(--fs-sm);
  }

  .card-description {
    margin: 0.5em 0 0;
    overflow: hidden;
    text-overflow: ellipsis;
    overflow-wrap: break-word;
    text-wrap: pretty;
    line-height: 1.2em;

    /* cap description at 3 lines, the 1px is to clean up some stray pixels
       TODO: fancier fade-out at the bottom to show off that it's too long?
     */
    max-height: calc(1.2em * 3 - 1px);
  }

  .nsfw-alert {
    margin: 2em 0;
  }

  color: var(--text);
  border-style: solid;
  border-width: 1px;
  border-radius: var(--roundness);
  border-color: var(--border);
}
</style>
